//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';
import UploadFile from '../../../../shared-components/upload/UploadFile';

import { basePath } from '../../../../common/resources/importacoes';
import { generateComputed } from '../../../../common/functions/roles-computed-generator';

export default {
  name: 'SellOutSideColumn',
  data() {
    return {
      dataInicio: '',
      dataFim: '',
    };
  },
  computed: {
    ...mapGetters('importacao', {
      tiposImportacao: 'getTiposImportacao',
    }),
    ...generateComputed('Sellout', [
      'canImport',
      'canExport',
    ]),
    showImport() {
      if ((!this.errors.has('data_inicio') && this.dataInicio !== '' && this.dataInicio.length === 10) &&
        (!this.errors.has('data_fim') && this.dataFim !== '' && this.dataFim.length === 10)) {
        return this.validarDatas();
      }
      return false;
    },
    tipoImportacao() {
      return this.tiposImportacao.find(el => el.nome === 'importacao_sellout');
    },
    uploadFileDropzoneId() {
      return `myVueDropzone${(Math.random() * Math.random() * 100).toString().replace('.', '')}`;
    },
    importUrl() {
      return `${basePath}/importacao`;
    },

  },
  components: {
    UploadFile,
  },
  methods: {
    enviandoArquivo(data, xhr, formData) {
      const parametros = { data_inicio: this.dataInicio, data_fim: this.dataFim };

      formData.append('id_tipo_importacao', 14);
      formData.append('parametros', JSON.stringify(parametros));
    },
    uploadError(file, msg) {
      this.$toast.create(msg || this.$t('message.erro_tente_importar_novamente'), 'snack', 5E3);
    },
    uploadSuccess() {
      this.$toast.create(this.$t('message.importado_em_breve_sera_processado'), 'snack', 8E3);
    },
    validarDatas() {
      const inicio = this.moment(this.dataInicio, 'DD-MM-YYYY');
      const fim = this.moment(this.dataFim, 'DD-MM-YYYY');
      if (inicio > fim) {
        this.$toast.create(this.$t('errors.data.final_antes_inicial'), 'snack', 8E3);
        return false;
      }
      return true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/sell-out/SellOutLateral.vue?vue&type=script&lang=js&